<div class="lg-footer">
    <div class="footer-row-1">
        <div class="footer-r1-c1"><span>Site best viewed with Chrome and Firefox browsers</span></div>
        <div class="footer-r1-c2" *ngIf="!msTeamAccess">
            <a *ngIf="domainId != '52'" title="ios App" href="{{iosAppUrl}}" target="_blank"><img src="assets/images/ios-download.png"></a>
            <a title="Android app" href="{{androidAppUrl}}" target="_blank"><img src="assets/images/android-download.png"></a>
        </div>        
    </div>  
    <div class="footer-row-2">
        <div class="footer-r2-c1">
            <span class="copy-text">&copy; {{PlatFormDomainsNames}} {{year}}. All rights reserved.</span>
            <ul>
                <li><span class="hide-ms">|</span></li>
                <li><a title="Support" target="_blank" href="https://www.collabtic.com/contact-us/" >Support</a></li>
                <li><span>|</span></li>
                <li><a title="Terms & Conditions" target="_blank" href="https://www.collabtic.com/terms-conditions" >Terms &amp; Conditions</a></li>
                <li><span class="hide-ms">|</span></li>
                <li><a title="Privacy Policy" target="_blank" href="https://www.collabtic.com/privacy-policy" >Privacy Policy</a></li>
            </ul>
        </div>
        <div class="footer-r2-c2" *ngIf="socialIconsFlag">
            <ul>
                <li><a title="twitter" href="https://twitter.com/collabtic" target="_blank"><img src="assets/images/login/twitter-icon.png"></a></li>
                <li><a title="facebook" target="_blank" href="https://www.facebook.com/collabtic" ><img src="assets/images/login/facebook-icon.png"></a></li>
            </ul>
        </div>
    </div>  
<div>


